import { SalesOrderStatus } from '../constants/sales-order-status.js';
/**
 * Statuses where a sales order's line items are no longer editable -- the order has shipped, been
 * delivered or completed (the goods have left, items are historical record) or it's been cancelled/rejected
 * (there's no live order to edit). Every other status, including post-Draft states like
 * Submitted/Accepted, allows add/update/remove so a correction doesn't require reverting the
 * order to Draft. Shared by addSalesOrderItem, updateSalesOrderItem, and removeSalesOrderItem so
 * a future status addition touches one line instead of three.
 */
export const BLOCKED_ITEM_EDIT_STATUSES = [
    SalesOrderStatus.SHIPPED,
    SalesOrderStatus.DELIVERED,
    SalesOrderStatus.COMPLETE,
    SalesOrderStatus.CANCELLED,
    SalesOrderStatus.REJECTED,
];
//# sourceMappingURL=blocked-item-edit-statuses.js.map